module.exports = __webpack_public_path__ + "img/kh1_03.8ab3bd2a.png";